import React, { memo } from "react";
import { renderRoutes } from "react-router-config";
import { Switch, Route, Router, withRouter } from "react-router-dom";

const UserLayout = (props) => {
  return <>{renderRoutes(props.route.routes)}</>;
};

export default withRouter(memo(UserLayout));
